import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

interface WrapperProps {
    canEdit?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
    display: flex;
    flex-direction: column;
    padding: ${token('space.200')};
    border-radius: 3px;
    cursor: ${({ canEdit = false }) => (canEdit ? 'pointer' : 'default')};
    box-shadow: 0px 0px 1px 0px rgba(9, 30, 66, 0.31), 0px 1px 1px 0px rgba(9, 30, 66, 0.25);
`;

export const TopSection = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: ${token('space.200')};
    margin-bottom: ${token('space.200')};
    border-bottom: 1px solid ${token('color.border.accent.gray')};

    .delete {
        cursor: pointer;
    }
`;

export const BannerName = styled.div`
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: ${token('color.text')};
`;

export const IssueInfo = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-weight: 600;
    color: ${token('color.text.subtlest')};
`;

export const CreatedSection = styled.div`
    display: flex;
    margin-bottom: ${token('space.100')};
`;

export const IssueLink = styled.div`
    cursor: pointer;
    color: ${token('color.link')};
`;
